import clock from '~/assets/icons/clock.svg';
import { CollectionImage } from '~/components/collections';
import { CurrencyIcon } from '~/components/collections/CurrencyIcon';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import {
	StyledContainer,
	StyledDec,
	StyledDividers,
	StyledImageContainer,
	StyledInfoBottomContainer,
	StyledInfoBottomItem,
	StyledInfoContainer,
	StyledNameContainer,
} from './AppTruckJobOrderItem.styled';

const AppTruckJobOrderItem = ({
	level,
	active = false,
}: {
	level: number;
	active?: boolean;
}) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer $level={level} $active={active}>
			<StyledImageContainer>
				{level > 1 && <StyledDec $level={level} />}
				<CollectionImage collection="items" id="wood" size="md" />
			</StyledImageContainer>
			<StyledDividers>
				<Divider $direction="V" $color="#000000" style={{ opacity: 0.5 }} />
				<Divider $direction="V" style={{ opacity: 0.1 }} />
			</StyledDividers>
			<StyledInfoContainer>
				<StyledNameContainer $level={level}>
					{level > 1 && <div className="dec" />}
					<Text>Древесина</Text>
				</StyledNameContainer>
				<Text
					style={{ fontSize: 12, color: '#FFFFFF', opacity: 0.5, marginTop: 4 }}
				>
					Склад 2 - Сэнди-Шорс
				</Text>
				<StyledInfoBottomContainer>
					<StyledInfoBottomItem>
						<CurrencyIcon icon={rubleIcon} size="sm" />
						<Text>13 000</Text>
					</StyledInfoBottomItem>
					<Divider $direction="V" />
					<StyledInfoBottomItem>
						<img src={clock} />
						<Text>13:00</Text>
					</StyledInfoBottomItem>
				</StyledInfoBottomContainer>
			</StyledInfoContainer>
			{/* <Button
				color={ButtonColors.LightGreen}
				height={ButtonHeight.Height60}
				style={{ padding: 0 }}
				noBorder
			>
				<img src={delivery} />
			</Button> */}
		</StyledContainer>
	);
};

export { AppTruckJobOrderItem };
